import runAccessibility from '@/views/menu/runAccessibility'
import adjustFontSize from '@/tools/adjustFontSize'
import { renderWidget } from '@/views/widget/widget'

import { userSettings, getSavedUserSettings } from '@/globals/userSettings'

import { pluginConfig } from './globals/pluginConfig'
import { changeLanguage } from './i18n/changeLanguage'

type SiennaOptions = Partial<typeof pluginConfig>

export default function sienna({ options }: { options: SiennaOptions }) {
  const savedSettings = getSavedUserSettings()
  userSettings.states = savedSettings.states ?? {}
  Object.assign(pluginConfig, options)

  runAccessibility()
  renderWidget()
  observeDOMChanges()

  return {
    changeLanguage,
  }
}

/**
 * Re-apply font size when DOM changes that aren't user-driven by the widget.
 *
 * Captures React re-renders, paginations, and async content (e.g.
 * SearchRecommendation) loading AFTER the initial page render.
 * adjustFontSize itself dedupes via dataset cache so we won't double-apply.
 */
function observeDOMChanges() {
  if (typeof window === 'undefined' || !document.body) return

  let debounceTimer: ReturnType<typeof setTimeout>
  const MIN_GAP_MS = 200

  const observer = new MutationObserver((mutations) => {
    // Skip mutations that are purely internal to the widget
    const hasExternalMutation = mutations.some((m) =>
      [...m.addedNodes, ...m.removedNodes].some((node) => {
        if (!(node instanceof Element)) return false
        const widget = document.querySelector('.asw-container')
        return widget && !widget.contains(node)
      }),
    )
    if (!hasExternalMutation) return

    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      const fontSize = Number((userSettings.states?.fontSize ?? 1).toFixed(2))
      if (!fontSize || fontSize === 1) return
      adjustFontSize(fontSize)
    }, MIN_GAP_MS)
  })

  observer.observe(document.body, { childList: true, subtree: true })
}
